module.exports = __webpack_public_path__ + "media/tutoring/red-tshirt-baac61ab.jpg";